module.exports = __webpack_public_path__ + "static/media/BlockProduct.df0a4e32.svg";